import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Photo } from '../models/photo';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SignatureService {
  private currentSignatureSubject: BehaviorSubject<Photo[]>;
  public currentSignature: Observable<Photo[]>;
  private _baseUrl: string = environment.apiUrl;

  /*
   * Build the api url call with the provided method name
   */
  private getApiUrlCall(methodName: string): string {
    let url = '';

    url = this._baseUrl + methodName;

    return url;
  }

  constructor() {}

  getSignature(signatureID: number): any {
    return `${this.getApiUrlCall(
      'api/v3/Mobiles/GetSignature'
    )}?signatureID=${signatureID}`;
  }
}
